import React from 'react'
import './DeleteBranchModal.css'
import { Dialog, DialogContent } from '@mui/material'
import { t } from 'i18next'

const DeleteBranchModal = ({ open, onClose, onConfirm, count = 1 }) => {
  const confirmDelete = async () => {
    await onConfirm()
  }

  const confirmationText =
    count > 1
      ? t('PICKING_FLOW_SETTINGS.LIST.DELETE_CONFIRM_TEXT_MULTIPLE', { count })
      : t('PICKING_FLOW_SETTINGS.LIST.DELETE_CONFIRM_TEXT')

  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="xs"
      data-testid="modal-delete-picking-flow-branch">
      <DialogContent
        className="picking-flow-delete-modal"
        data-testid="content-delete-picking-flow-branch">
        <div>
          <div className="delete-picking-flow-confirmation-message">
            <p
              className="delete-picking-flow-confirmation-text"
              data-testid="text-confirm-delete-picking-flow-branch">
              {confirmationText}
            </p>
          </div>
          <div
            className="delete-picking-flow-modal-buttons"
            data-testid="actions-delete-picking-flow-branch">
            <button
              type="button"
              data-testid="btn-confirm-delete-picking-flow-branch"
              onClick={confirmDelete}
              className="btn modal-si">
              {t('PICKING_FLOW_SETTINGS.LIST.YES_OPTION')}
            </button>
            <button
              type="button"
              data-testid="btn-cancel-delete-picking-flow-branch"
              onClick={onClose}
              className="btn modal-no">
              {t('PICKING_FLOW_SETTINGS.LIST.NO_OPTION')}
            </button>
          </div>
        </div>
      </DialogContent>
    </Dialog>
  )
}

export default DeleteBranchModal
